import { render, staticRenderFns } from "./ButtonChat.vue?vue&type=template&id=a7fb33d8&scoped=true&"
import script from "./ButtonChat.vue?vue&type=script&lang=js&"
export * from "./ButtonChat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChat.vue?vue&type=style&index=0&id=a7fb33d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fb33d8",
  null
  
)

export default component.exports